import { ReactComponent as BulkEditIcon } from './bulkEdit.svg';

export default BulkEditIcon;
